import React from 'react';

import EmailFilter from '../EmailFilter';
import FilterDrawerHeader from '../FilterDrawerHeader';
import SuperBatchFilter from '../SuperBatchFilter';

function FilterDrawerContent() {
  return (
    <>
      <FilterDrawerHeader />
      <div className="m-t-m m-b-xs h3 bold dark">All Filters</div>
      <EmailFilter />
      <SuperBatchFilter />
    </>
  );
}

export default FilterDrawerContent;
